import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import TemplatesApi from "../../../api/templates-api";

export const useTemplates = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    fetchTemplates();
  }, [currentPage]);

  const fetchTemplates = async () => {
    try {
      setLoading(true);
      const {data: response} = await TemplatesApi.private.getAllExternalTemplates({
        page: currentPage,
        limit: 10,
      });
      console.log(response);
      if (response && !response.error) {
        setTemplates(response.data.docs);
        setTotalPages(response.data.totalPages);
      } else {
        toast.error("Failed to fetch templates");
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
      toast.error("An error occurred while fetching templates");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const createTemplate = async (templateData) => {
    try {
      const response = await TemplatesApi.private.createExternalTemplate(templateData);
      
      if (response && !response.error) {
        toast.success("Template created successfully");
        fetchTemplates(); // Refresh the templates list
        return { success: true };
      } else {
        toast.error("Failed to create template");
        return { success: false };
      }
    } catch (error) {
      console.error("Error creating template:", error);
      toast.error("An error occurred while creating the template");
      return { success: false };
    }
  };

  const updateTemplate = async (templateId, templateData) => {
    try {
      const response = await TemplatesApi.private.updateExternalTemplate(
        templateId,
        templateData
      );
      
      if (response && !response.error) {
        toast.success("Template updated successfully");
        fetchTemplates(); // Refresh the templates list
        return { success: true };
      } else {
        toast.error("Failed to update template");
        return { success: false };
      }
    } catch (error) {
      console.error("Error updating template:", error);
      toast.error("An error occurred while updating the template");
      return { success: false };
    }
  };

  const updateTemplateInList = (updatedTemplate) => {
    setTemplates(prevTemplates => 
      prevTemplates.map(template => 
        template._id === updatedTemplate._id ? updatedTemplate : template
      )
    );
  };

  return {
    templates,
    loading,
    currentPage,
    totalPages,
    handlePageChange,
    createTemplate,
    updateTemplate,
    updateTemplateInList,
    refreshTemplates: fetchTemplates
  };
}; 